// /support-access — временный доступ сопровождения: действующий и закончившийся. Право —
// support.read: администратор видит весь, сопровождение — свой. Поиск, состояние и сортировка —
// в адресе страницы (?q=&state=&sort=; T063, T131): ссылку можно переслать, назад — те же условия.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { SupportAccessPage } from '../../../features/support-access/SupportAccessPage.tsx';
import { parseSupportAccessSearch } from '../../../features/support-access/search.ts';
import type { SupportAccessSearch } from '../../../features/support-access/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/support-access')({
  validateSearch: parseSupportAccessSearch,
  beforeLoad: requireSection('support'),
  staticData: { crumb: 'Доступ сопровождения' },
  component: SupportAccessRoute,
});

function SupportAccessRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: SupportAccessSearch) =>
      void navigate({ to: '/support-access', search: next, replace: true }),
    [navigate],
  );
  return <SupportAccessPage search={search} onSearchChange={onSearchChange} />;
}
